import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  CustomTestInteractionSchema,
  CustomTestReduxSchema,
  SubjectCustomTestReduxSchema,
} from "@tsTypes/redux-schema";
import {
  createMissingSubject,
  getBlankResource,
  isoStringToUnixDay,
} from "../../lib/redux/helpers";

const initialState: SubjectCustomTestReduxSchema = {};

export const CustomTestUserReduxMetadataSlice = createSlice({
  name: "CustomTestUserReduxMetadata",
  initialState,
  reducers: {
    setCustomTestState: (
      state,
      action: PayloadAction<
        | {
            [subjectDocumentId: string]:
              | {
                  [customTestDocumentId: string]: CustomTestReduxSchema;
                }
              | undefined;
          }
        | undefined
      >,
    ) => {
      return { ...action.payload };
    },
    customTestAttempt: (
      state,
      action: PayloadAction<CustomTestInteractionSchema>,
    ) => {
      const {
        subjectDocumentId,
        includedSubTopics,
        customTestId,
        date,
        mcMarks,
        laMarks,
        numQuestions,
        percentagePerformance,
        percentageFree,
      } = action.payload;
      if (!state[subjectDocumentId]) {
        state[subjectDocumentId] = createMissingSubject();
      }
      if (!state[subjectDocumentId][customTestId]) {
        state[subjectDocumentId][customTestId] = getBlankResource(
          "customTests",
        ) as CustomTestReduxSchema;
      }
      // Overwrite draft meta above with correct data. Also handles case where question already existed and just needed updating
      state[subjectDocumentId][customTestId].subTopicDocumentIds = [
        ...includedSubTopics,
      ];
      state[subjectDocumentId][customTestId].mcMarks = mcMarks;
      state[subjectDocumentId][customTestId].laMarks = laMarks;
      state[subjectDocumentId][customTestId].numQuestions = numQuestions;
      state[subjectDocumentId][customTestId].da.push(isoStringToUnixDay(date));
      state[subjectDocumentId][customTestId].perf.push(percentagePerformance);
      state[subjectDocumentId][customTestId].freeTimes.push(percentageFree);
    },
  },
});

export const { customTestAttempt, setCustomTestState } =
  CustomTestUserReduxMetadataSlice.actions;

export default CustomTestUserReduxMetadataSlice.reducer;
